import React, { useState, useEffect } from "react";
import "./PvgHeader.css";
import logo from '../../Asset/Image/PVG_Logo.png'; // Make sure this path is correct for your logo

const PvgHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = [
        "home",
        "divisions",
        "solutions",
        "About",
        // "testimonials",
        "careers",
        "contact",
      ];
      const current = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });

      if (current) {
        setActiveSection(current);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "unset" : "hidden";
  };

  // Close mobile menu when clicking on a link
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "unset";
  };

  // Smooth scroll to section
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMenu();
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  return (
    <header
      className={`pvg-header ${isScrolled ? "pvg-header--scrolled" : ""} ${
        isMenuOpen ? "pvg-header--menu-open" : ""
      }`}
    >
      <div className="pvg-header__container">
        <nav className="pvg-header__nav">
          {/* Logo Section */}
          <div className="pvg-header__brand">
            <a
              href="#home"
              className="pvg-header__logo"
              onClick={(e) => handleNavClick(e, "home")}
            >
              <div className="pvg-header__logo-icon">
                <img 
                  src={logo} 
                  alt="Prime Ventures Global Logo" 
                  className="pvg-header__logo-image"
                />
              </div>
              <div className="pvg-header__logo-content">
                <span className="pvg-header__logo-title">
                  Prime Ventures Global
                </span>
                <span className="pvg-header__logo-subtitle">
                  INNOVATION WITHOUT BORDERS
                </span>
              </div>
            </a>
          </div>

          {/* Navigation Menu */}
          <div className="pvg-header__menu">
            <ul
              className={`pvg-header__nav-list ${
                isMenuOpen ? "pvg-header__nav-list--active" : ""
              }`}
            >
              <li className="pvg-header__nav-item">
                <a
                  href="#home"
                  className={`pvg-header__nav-link ${
                    activeSection === "home"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "home")}
                >
                  <i className="pvg-header__nav-icon fas fa-home"></i>
                  <span>Home</span>
                </a>
              </li>
              <li className="pvg-header__nav-item">
                <a
                  href="#divisions"
                  className={`pvg-header__nav-link ${
                    activeSection === "divisions"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "divisions")}
                >
                  <i className="pvg-header__nav-icon fas fa-cogs"></i>
                  <span>Divisions</span>
                </a>
              </li>
              <li className="pvg-header__nav-item">
                <a
                  href="#About"
                  className={`pvg-header__nav-link ${
                    activeSection === "About"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "About")}
                >
                  <i className="pvg-header__nav-icon fas fa-lightbulb"></i>
                  <span>About</span>
                </a>
              </li>
              {/* <li className="pvg-header__nav-item">
                <a
                  href="#portfolio"
                  className={`pvg-header__nav-link ${
                    activeSection === "portfolio"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "portfolio")}
                >
                  <i className="pvg-header__nav-icon fas fa-briefcase"></i>
                  <span>Portfolio</span>
                </a>
              </li> */}
              {/* <li className="pvg-header__nav-item">
                <a
                  href="#testimonials"
                  className={`pvg-header__nav-link ${
                    activeSection === "testimonials"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "testimonials")}
                >
                  <i className="pvg-header__nav-icon fas fa-comments"></i>
                  <span>Testimonials</span>
                </a>
              </li> */}
              <li className="pvg-header__nav-item">
                <a
                  href="#careers"
                  className={`pvg-header__nav-link ${
                    activeSection === "careers"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "careers")}
                >
                  <i className="pvg-header__nav-icon fas fa-users"></i>
                  <span>Careers</span>
                </a>
              </li>
              <li className="pvg-header__nav-item">
                <a
                  href="#contact"
                  className={`pvg-header__nav-link ${
                    activeSection === "contact"
                      ? "pvg-header__nav-link--active"
                      : ""
                  }`}
                  onClick={(e) => handleNavClick(e, "contact")}
                >
                  <i className="pvg-header__nav-icon fas fa-envelope"></i>
                  <span>Contact</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className={`pvg-header__hamburger ${
              isMenuOpen ? "pvg-header__hamburger--active" : ""
            }`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="pvg-header__overlay" onClick={closeMenu}></div>
      )}
    </header>
  );
};

export default PvgHeader;